import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { useNavigate } from 'react-router-dom';
import { FaRegEdit } from "react-icons/fa";
import { getCmsList } from '../../actions/users';

const ResourceFooterList = () => {


    const navigate = useNavigate();


    const [resourceList, setResourceList] = useState([]);

    function editR(id) {
        navigate('/editcms/' + id)
    }

    const getresourcelist = async () => {
        var { cmsData } = await getCmsList();
        
        setResourceList(cmsData);
    }

    useEffect(() => {
        getresourcelist();
    }, [])

    const columns = [

        {

            key: "Title",
            name: "Title",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>{row?.identifier}</p>
            ),

        },       
        {

            key: "Action",
            name: "Action",
            // className: "tokenQuantity",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                              onClick={() => editR(row?._id)}

                            style={{ marginRight: '5px' }}
                        >
                            <FaRegEdit />
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    return (
        <Layout>
            <div className="cmslist">
                <h1 className="pagehead">Resource & Footer</h1>
                <div className="cardbox">
                    <div className="tablebox">
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={resourceList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default ResourceFooterList;